import { Route } from 'react-router-dom'
import { SHELL_ROUTES } from './pages.ts'

/**
 * SHELL_ROUTES as <Route> elements, to place inside a parent <Route>.
 * A plain function, not a component: <Routes> only accepts <Route> children.
 */
export function shellRouteElements() {
  return SHELL_ROUTES.map((route) =>
    'index' in route ? (
      <Route key="index" index element={<route.Page />} />
    ) : (
      <Route key={route.path} path={route.path} element={<route.Page />} />
    ),
  )
}
